import { render, staticRenderFns } from "./printer-template.vue?vue&type=template&id=9438455e&scoped=true&"
import script from "./printer-template.vue?vue&type=script&lang=js&"
export * from "./printer-template.vue?vue&type=script&lang=js&"
import style0 from "./printer-template.vue?vue&type=style&index=0&id=9438455e&scoped=true&lang=css&"
import style1 from "./printer-template.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9438455e",
  null
  
)

export default component.exports